<script setup>
import { ref, onMounted } from 'vue'
import { useDetectDevice } from '@/composables/device'
import { usePlanningStore } from '@/stores/planning.store'

import StaffMovementsView from '@/components/planner/StaffMovementsView.vue'
import StaffMovementsGrid from '@/components/planner/StaffMovementsGrid.vue'

const { isMobile } = useDetectDevice()
const planningStore = usePlanningStore()

const ready = ref(false)

onMounted(async () => {
  const fetches = []
  if (!planningStore.staff?.length) fetches.push(planningStore.fetchStaffsAsync({ all: true }, true))
  if (!planningStore.projects?.length) fetches.push(planningStore.fetchProjectsAsync({ all: true }, true))
  await Promise.all(fetches)
  ready.value = true
})
</script>

<template>
  <staff-movements-view v-if="isMobile && ready" />
  <staff-movements-grid v-else-if="ready" />
</template>
